import { ReqGet } from '../../config/Requests';
import {
	jobListRequestInitiated,
	jobListRequestSuccess,
	jobListRequestFailed,
	searchJobListRequestInitiated,
	searchJobListRequestSuccess,
	searchJobListRequestFailed,
} from './actions';

export const jobRequest = params => async (dispatch, getState) => {
	const isInitiated = getState().data.isInitiated;
	const isSuccess = getState().data.isSuccess;
	if (isInitiated && isSuccess) {
		return null;
	}

	dispatch(jobListRequestInitiated());
	ReqGet('jobs', null, { params })
		.then(res => {
			if (!res.data.data) {
				dispatch(jobListRequestFailed('Data not found'));
			} else {
				dispatch(jobListRequestSuccess(res.data.data));
				return res.data.data;
			}
		})
		.catch(err => {
			dispatch(err.message);
		});
};

export const searchJobRequest = params => async (dispatch, getState) => {
	dispatch(searchJobListRequestInitiated());

	if (!params) {
		ReqGet('jobs', null)
			.then(res => {
				if (!res.data.data) {
					dispatch(searchJobListRequestFailed('Data not found'));
				}
				dispatch(jobListRequestSuccess(res.data.data));
				return res.data.data;
			})
			.catch(err => {
				dispatch(searchJobListRequestFailed(err.message));
			});
	}
	ReqGet('jobs', null, { params })
		.then(res => {
			if (!res.data.data) {
				dispatch(searchJobListRequestFailed('Data not found'));
			}
			dispatch(searchJobListRequestSuccess(res.data.data));
			return res.data.data;
		})
		.catch(err => {
			dispatch(searchJobListRequestFailed(err.message));
		});
};
